import script from "./ArchiveInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./ArchiveInfo.vue?vue&type=script&setup=true&lang=js"

import "./ArchiveInfo.vue?vue&type=style&index=0&id=8857fc18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8857fc18"]])

export default __exports__